import { GET_ALL_CENTROS_DE_CUSTO } from './mutation-types'

export default {
  [GET_ALL_CENTROS_DE_CUSTO]: (state, centrosDeCusto) => {
    state.centrosDeCusto = centrosDeCusto
  },
}
